//
import CustomerModel from "@/models/Sale/SlCustomer"
import UserModel from "@/models/General/GUser"

//
export default {

  /**
   * 
   */
  toList() {
    return [
      {
        name: "sl_customer_id",
        type: "autocomplete-model",
        props: {
          itemText: "business_name",
          itemValue: "id",
          label: "Cliente",
          model: CustomerModel,
          noObject: true,
          paramSearch: "search",
        },
        trigger(ctx) {
          ctx.getField('sl_customer_branch_offices_id').props.items = ctx.getInput('sl_customer_id').getSelected().branch_offices
          ctx.$forceUpdate()
        },
      },
      {
        name: 'sl_customer_branch_offices_id',
        type: 'select',
        props: {
          label: 'Sucursal',
          items: [],
          itemText: 'address',
          itemValue: 'id',
          noObject: true,
        },
      },
      {
        name: "g_user_id",
        type: "autocomplete-model",
        props: {
          itemText: "full_name",
          itemValue: "id",
          label: "Responsable",
          model: UserModel,
          noObject: true,
        },
      },
    ]
  }
}
